import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { defaultNS, resources, type SupportedLanguage, supportedLanguages } from '@/locales';

/**
 * Idioma detectado (do navegador ou o salvo antes) → um dos suportados, pela LÍNGUA: `en-GB` e
 * `en-CA` viram inglês, `es-MX` e `es-AR` espanhol, `pt-PT` português. Sem isso só o código exato
 * (`en-US`, `es-ES`, `pt-BR`) casava e quem tem o navegador em `es-MX` via tudo em português.
 * Língua que não temos (francês, por exemplo) fica em português, o idioma da empresa.
 */
export function idiomaSuportado(detectado: string): SupportedLanguage {
  const lingua = detectado.slice(0, 2).toLowerCase();
  return supportedLanguages.find((l) => l.slice(0, 2) === lingua) ?? 'pt-BR';
}

// `<html lang>` acompanha o idioma da tela: leitores de tela pronunciam pelo idioma declarado e o
// Chrome oferece "traduzir do português" numa página que já está em inglês.
const sincronizarLang = (idioma: string) => {
  document.documentElement.lang = idioma;
};
i18n.on('languageChanged', sincronizarLang);

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    fallbackLng: 'pt-BR',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      convertDetectedLanguage: idiomaSuportado,
    },
  })
  .then(() => sincronizarLang(i18n.language));

export default i18n;
